import { useEffect } from 'react';
import { useMyContext } from 'Context/MyContextProvider';

const usePermissionGuard = (permission, redirectPath = '/404') => {
    const { Permisson, navigate } = useMyContext();

    useEffect(() => {
        if (!Permisson?.includes(permission)) {
            navigate(redirectPath);
        }
    }, [Permisson, permission, navigate, redirectPath]);
};

export default usePermissionGuard;